// extracted by mini-css-extract-plugin
module.exports = {"downloading-tip":"downloading-tip___2ietE"};